<template>
  <div class="auth-wrapper auth-v1 px-2">
    <AnimatedAiBackground />
    <div class="auth-inner py-2">
      <b-card class="mb-0">
        <b-link class="brand-logo d-block">
          <div
            style="width: 300px"
            class="d-flex align-items-center justify-content-center mb-1 m-auto"
          >
            <img style="width: 100%" src="/sofIAweb.webp" alt="SofIA" />
          </div>
          <h4 class="brand-text text-center">
            {{ $t("pages.login.salesFuture") }}, <br />
            {{ $t("pages.login.unlock") }}
          </h4>
        </b-link>
        <validation-observer ref="loginForm" #default="{ invalid }">
          <b-form class="auth-login-form mt-2" @submit.prevent="login">
            <b-form-group label-for="email" :label="$t('pages.login.email')">
              <validation-provider
                #default="{ errors }"
                :name="$t('pages.login.email')"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="userEmail"
                  name="login-email"
                  :state="errors.length > 0 ? false : null"
                  :placeholder="$t('pages.login.email')"
                  autofocus
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group>
              <div class="d-flex justify-content-between">
                <label for="password">{{ $t("pages.login.password") }}</label>
              </div>
              <validation-provider
                #default="{ errors }"
                :name="$t('pages.login.password')"
                rules="required"
              >
                <b-input-group
                  class="input-group-merge"
                  :class="errors.length > 0 ? 'is-invalid' : null"
                >
                  <b-form-input
                    id="password"
                    v-model="password"
                    :type="passwordFieldType"
                    class="form-control-merge"
                    :state="errors.length > 0 ? false : null"
                    name="login-password"
                    :placeholder="$t('pages.login.password')"
                  />

                  <b-input-group-append is-text>
                    <feather-icon
                      class="cursor-pointer"
                      :icon="passwordToggleIcon"
                      @click="togglePasswordVisibility"
                    />
                  </b-input-group-append>
                </b-input-group>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-button variant="primary" type="submit" block :disabled="invalid">
              {{ $t("pages.login.login") }}
            </b-button>
          </b-form>
          <div
            @click="forgotPasswordFunction()"
            class="d-flex align-items-center justify-content-center mt-1"
          >
            <p class="forgotPassOption">
              {{ $t("pages.login.forgotPassword") }}
            </p>
          </div>
        </validation-observer>
      </b-card>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BInputGroup,
  BInputGroupAppend,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import { required, email } from "@validations";
import { togglePasswordVisibility } from "@core/mixins/ui/forms";
import { loginCustomer } from "@core/api/request";
import { getHomeRouteForLoggedInUser } from "@/auth/utils";
import { setCookie, deleteCookie } from "@/auth/CookiesManager";
import { showLoading, stopLoading } from "@core/utils/utils";
import AnimatedAiBackground from "../../landing/AnimatedAiBackground.vue";
import { getProfile } from "@/@core/api/request/profiles";
import sessionBuilder from "@/security/context/sessionContext";

const profile = {
  guid: null,
  name: null,
  permissions: [],
};

export default {
  components: {
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BLink,
    VuexyLogo,
    BInputGroup,
    BInputGroupAppend,
    ValidationProvider,
    ValidationObserver,
    AnimatedAiBackground,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      userEmail: "",
      password: "",
      status: "",
      required,
      email,
      profile: Object.assign(profile),
    };
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  watch: {
    "$i18n.locale"(locale) {
      localize(locale);
    },
  },
  created() {
    localize(this.$i18n.locale);
  },
  methods: {
    login() {
      this.$refs.loginForm.validate().then((success) => {
        if (success) {
          this.$store.commit("appConfig/SET_RESET_SESSION_CONTEXT");
          this.$store.commit("appConfig/CLEAR_ACTIVE_COMPANY");

          showLoading();
          const user = {
            email: this.userEmail,
            password: this.password,
          };
          let userJwt = null;
          loginCustomer(user)
            .then(async (response) => {
              userJwt = this.parseJwt(response.data);
              // console.log("userJwt", userJwt);
              // console.log("response", response);
              if (response.err) {
                const message = _.get(response, "data.message");
                this.$refs.loginForm.setErrors(
                  message || "Error en autenticación",
                );
                this.alertToast(
                  "danger",
                  "Alerta error",
                  message || "Error en autenticación",
                  "AlertTriangleIcon",
                );
                return;
              }
              if (!response?.token) {
                this.alertToast(
                  "danger",
                  "Alerta error",
                  "No existe token",
                  "AlertTriangleIcon",
                );
                return;
              }

              this.$store.commit("appConfig/SET_TOKEN", response.token);
              setCookie("token", response.token, 1);

              await this.getProfileUser(
                userJwt?.guidProfile,
                userJwt,
                response.token,
              );

              const userData = {};
              userData.role = userJwt.role = userJwt.nameProfile
                .toUpperCase()
                .replace(/\s/g, "");
              userData.Name = userJwt.Name;
              userData.nameProfile = userJwt.nameProfile;

              setCookie("role", userData.role, 1);
              setCookie("user", JSON.stringify(userData), 1);
              setCookie("logout", false, 1);

              this.$store.commit("appConfig/UPDATE_USER", userJwt);
              this.$store.commit("appConfig/SET_ROLE", userData.role);

              this.$ability.update([{ action: "manage", subject: "all" }]);

              const homeRoute = getHomeRouteForLoggedInUser(userData.role);
              this.$router.replace(homeRoute).then(() => {});
            })
            .catch((error) => {
              const message =
                error?.message ||
                error?.data?.message ||
                error?.response?.data?.message ||
                "Ocurrió un error al iniciar sesión";

              console.log("error", error);
              this.alertToast("danger", "Error", message, "AlertTriangleIcon");
            })
            .finally(() => {
              stopLoading();
            });
        }
      });
    },

    buildUserData(userJwt) {
      return {
        role: String(userJwt?.nameProfile || "")
          .toUpperCase()
          .replace(/\s/g, ""),
        Name: userJwt?.Name,
        nameProfile: userJwt?.nameProfile,
        photo: userJwt?.photo,
        nameSuscription: userJwt?.nameSuscription,
        fechaInicioSuscription: userJwt?.fechaInicioSuscription,
        fechaFinSuscription: userJwt?.fechaFinSuscription,
      };
    },

    parseJwt(token) {
      var base64Url = token.split(".")[1];
      var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      var jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map((c) => {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join(""),
      );
      return JSON.parse(jsonPayload);
    },

    alertToast(type = null, title = null, message = null, icon) {
      this.$bvToast.toast(message, {
        title,
        variant: type,
        solid: true,
        icon,
      });
    },

    forgotPasswordFunction() {
      this.$router.push({
        name: "forgot-password",
      });
    },

    getProfileUser(guidProfile, userJwt, token) {
      showLoading();
      return getProfile(guidProfile)
        .then((resp) => {
          const response = _.get(resp, "data");
          this.profile = Object.assign(this.profile, {
            guid: response.guid,
            name: response.name,
            permissions: response.permissions,
          });

          const tasaDolar =
            userJwt?.DolarBCV === "False" || userJwt?.dolarBCV === false
              ? userJwt.TasaDolar
              : null;

          const nameCoinType =
            typeof userJwt?.nameCoinType === "string"
              ? userJwt.nameCoinType.trim() || null
              : null;

          const ivaValue = Number(userJwt?.iva);
          const iva =
            userJwt?.iva !== null &&
            userJwt?.iva !== undefined &&
            userJwt?.iva !== "" &&
            Number.isFinite(ivaValue) &&
            ivaValue >= 0 &&
            ivaValue <= 100
              ? ivaValue
              : null;

          const famcosValue = (() => {
            const raw = userJwt?.Famcos;

            if (raw == null) return false;

            if (typeof raw === "boolean") {
              return raw;
            }

            if (typeof raw === "string") {
              return /^true$/i.test(raw.trim());
            }

            return false;
          })();

          this.$store.commit("appConfig/SET_DIVISA", nameCoinType);
          this.$store.commit("appConfig/SET_IVA", iva);
          const sessionContext = sessionBuilder.build({
            token: token || null,
            refreshToken: null,
            idUser: userJwt?.idUser || null,
            idCompany: userJwt?.idCompany || null,
            idProfile: userJwt?.idProfile || null,
            idCatType: response.idCatType || null,
            profileName: userJwt?.nameProfile || null,
            // companyType: userJwt?.companyType || null,
            famcos: famcosValue,
            menuPermissions: response.permissions || [],
            features: userJwt?.features || [],
            activeCompanyGuid: userJwt?.guidCompany || null,
            idCatCoinType: userJwt?.idCatCoinType || null,
            nameCoinType,
            iva,
            statusSuscription: userJwt?.statusSuscription || null,
            nameSuscription: userJwt?.nameSuscription || null,
            fechaInicioSuscription: userJwt?.fechaInicioSuscription || null,
            fechaFinSuscription: userJwt?.fechaFinSuscription || null,
            dolarBCV: userJwt?.dolarBCV || null,
            tasaDolar: userJwt?.tasaDolar || null,
            photo: userJwt?.photo || null,
            guidProfile: userJwt?.guidProfile || null,
            isEmployee: userJwt?.isEmployee ?? false,
            idEmployee: userJwt?.idEmployee ?? null,
          });

          this.$store.commit("appConfig/SET_SESSION_CONTEXT", sessionContext);
          if (userJwt?.guidCompany) {
            this.$store.commit(
              "appConfig/SET_ACTIVE_COMPANY",
              userJwt.guidCompany,
            );

            // this.$store.commit("appConfig/SET_ID_COMPANY", userJwt.idCompany);
          }
        })
        .catch((error) => {
          console.log("error", error);
          this.alertToast(
            "danger",
            "Error",
            error.message,
            "AlertTriangleIcon",
          );
        })
        .finally(() => {
          stopLoading();
        });
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";
</style>

<style lang="scss" scoped>
.forgotPassOption {
  cursor: pointer;
}
.sofia-logo-4 {
  position: absolute;
  left: 70%;
  width: 400px;
  top: 15rem;
}

@media (max-width: 768px) {
  .sofia-logo-4 {
    display: none;
  }
}
@media (max-width: 480px) {
  .sofia-logo-4 {
    display: none;
  }
}
</style>
